<template>
  <form @submit.prevent="save">
    <b-message type="is-danger" v-if="errors.length > 0">
      <p v-for="error in errors">{{error}}</p>
    </b-message>
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('announce.title')} (ru) *`" v-model="form.name_ru"></form-input>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field>
          <form-input :label="`${$t('announce.title')} (uz) *`" v-model="form.name_uz"></form-input>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea :label="`${$t('interface.description')} (ru) *`" v-model="form.text_ru"></form-textarea>
        </b-field>
      </div>
      <div class="column is-12">
        <b-field>
          <form-textarea :label="`${$t('interface.description')} (uz) *`" v-model="form.text_uz"></form-textarea>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker :label="`${$t('interface.start_date')} *`"
                           :min-date="minDate"
                           v-model="form.start_date">
          </form-datepicker>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <form-datepicker :label="`${$t('interface.end_date')} *`"
                           :min-date="minDate"
                           v-model="form.end_date">
          </form-datepicker>
        </b-field>
      </div>
      <div class="column is-12">
        <b-checkbox v-model="allEmployees">{{ $t('interface.allEmployees') }}</b-checkbox>
      </div>
      <template v-if="!allEmployees">
        <div class="column is-6">
          <b-select class="p-0"
                    multiple
                    native-size="6"
                    v-model="selectedEmployees">
            <option v-for="employee in employeeList" :value="employee.id">{{ employee.initials }}</option>
          </b-select>
        </div>
        <div class="column is-6">
          <p class="has-text-grey-light" v-html="$t('interface.employeeSelectTip')"></p>
        </div>
      </template>
    </div>
    <div class="field is-grouped mt-10">
      <div class="control">
        <button type="submit" class="button is-primary">{{ $t('interface.save') }}</button>
      </div>
      <div class="control">
        <button class="button is-danger" @click.prevent="cancel">{{ $t('interface.cancel') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapState} from 'vuex'
  import {prepareDate} from '@/utils'
  import moment from 'moment'

  export default {
    props: ['announcementData', 'editMode'],
    data() {
      return {
        form: this.announcementData || {
          name_ru: '',
          name_uz: '',
          text_ru: '',
          text_uz: '',
          employees: [],
          start_date: new Date(),
          end_date: new Date()
        },
        minDate: moment().subtract(1, 'days').toDate(),
        isEdit: this.editMode || false,
        errors: [],
        allEmployees: true,
        selectedEmployees: this.announcementData ? this.announcementData.employees : []
      }
    },
    methods: {
      validate() {
        if (this.form.name_ru === '' || this.form.name_uz === '' ||
            this.form.text_ru === '' || this.form.text_uz === '') {
          this.errors.push(this.$t('interface.requiredFields'))
        }
        return this.errors.length === 0
      },
      save() {
        if (this.validate()) {
          this.$emit('save', {
            ...this.form,
            employees: this.allEmployees ? this.employeeList.map(employee => employee.id) : this.selectedEmployees,
            start_date: this.form.start_date ? prepareDate(this.form.start_date) : null,
            end_date: this.form.end_date ? prepareDate(this.form.end_date) : null
          })
        }
      },
      cancel() {
        this.$router.go(-1)
      }
    },
    mounted() {
      this.$store.dispatch('Announcement/getEmployeeList')
    },
    computed: {
      ...mapState('Announcement', ['employeeList'])
    },
    watch: {
      announcementData(data) {
        this.form = data
      }
    }
  }
</script>